import { FC, useMemo } from 'react';

import { useLocation, Navigate } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { Pagination } from 'components/parts/Pagination';
import { RootState } from 'store';

import { EventItem } from 'components/pages/Events/components/EventItem';

import { usePageTitle } from 'hooks/usePageTitle';

import styles from './Events.module.scss';

export const Events: FC = () => {
  // URLパラメータから開始ページを取得
  const query = new URLSearchParams(useLocation().search);
  const startPage = query.get('page') || 1;

  // 全ての記事データ
  const allList = useSelector((state: RootState) => state.event.list) || [];

  // 1ページ内に表示する件数
  const max = 10;

  // ページネーションで表示中の記事データ
  const list = useMemo(() => {
    const start = (+startPage - 1) * max;
    const end = start + max;
    return allList.slice(start, end);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allList, startPage, max, startPage]);

  // titleタグの設定
  usePageTitle(`EVENT`);

  // カレントページと紐づく記事がない場合は404ページへリダイレクト
  return list.length === 0 && +startPage !== 1 ? (
    <Navigate replace to="/404" />
  ) : (
    <div className={styles.events}>
      <div className={styles.read}>
        <p className={styles.paragraph}>
          Future
          Explorationsプロジェクトに関連するイベント情報です。100年先の未来の景色を一緒に想像できるワークショップやイベントにご参加いただけます。
        </p>
      </div>
      <div className={styles.list}>
        {list.map(item => (
          <EventItem key={item.id} {...item} />
        ))}
      </div>
      <Pagination totalCount={allList.length} startPage={+startPage} max={max} />
    </div>
  );
};
